export function DatabaseSyncDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.UPDATE)
        .setCustomActions({
	        'updateOffline': {
                method: 'POST'
            },
            'getCliSnippet': {
                method: 'GET',
                path: XRAY_RESOURCE.CLI_GENERATE_COMMAND
            },
            'updateOnline': {
                method: 'POST',
                path: XRAY_RESOURCE.START_UPDATE
            },
            'pauseOnline': {
                method: 'POST',
                path: XRAY_RESOURCE.PAUSE_UPDATE
            },
            'getStatus': {
                method: 'GET',
                path: XRAY_RESOURCE.GET_STATUS
            },
	        'abortSync': {
		        method: 'POST',
		        path: XRAY_RESOURCE.ABORT_UPDATE
	        }
        })
        .getInstance();

}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/database_sync_dao.js